import { AuthenticatedTemplate, UnauthenticatedTemplate } from '@azure/msal-react'
import { CssBaseline, ThemeProvider } from '@mui/material'
import React from 'react'
import './App.css'
const Home = React.lazy(() => import('./modules/home/Home'))
import rcmBlueTheme from './shared/themes/RcmBlue'
import { AppPublicRoutes } from './App.Public.Routes'

const App: React.FC = () => {
  return (
    <ThemeProvider theme={rcmBlueTheme}>
      <AuthenticatedTemplate>
        <CssBaseline />
        <React.Suspense>
          <Home />
        </React.Suspense>
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <AppPublicRoutes />
      </UnauthenticatedTemplate>
    </ThemeProvider>
  )
}

export default App
